<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('bob_label_635b966932dbf7514c031f10') }}{{customHeaderText}}</h1></div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info"><span><i
        class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ аукција') }}</span></div>
    </div>
    <!--    <div class="page-part" >-->
    <!--      <div class="page-actions">-->
    <!--        <button class="btn btn-success" (click)="routerNavigateToCreate()"><i-->
    <!--          class="fa fa-plus mr-1"></i> {{ translationManager.getTranslation('Додати нови') }}</button>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="app-table-panel" app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span></div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span></div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype><span><i
            search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                                              search-tag-prototype-value></i></span><a href="javascript:;"
                                                                                       [title]="translationManager.getTranslation('Обрисати филтер')"
                                                                                       search-tag-prototype-close><i
            class="fas fa-times"></i></a></div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
               order-tag-prototype><span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                                                                             order-tag-prototype-value></i></span><a
            href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
            order-tag-prototype-close><i class="fas fa-times"></i></a></div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon"><a href="javascript:;"
                                              [title]="translationManager.getTranslation('Филтрирај ентитете')"
                                              filter-open><i class="fas fa-filter"></i></a></div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title"><span>{{ translationManager.getTranslation('Филтери') }}</span><a
              href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close><i
              class="fas fa-times"></i></a></div>
            <div class="page-part">
              <div class="alert alert-info"><span><i
                class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Број захтева')}}</label>
                <div class="app-form-element-content">
                  <input type="number"
                        search-input search-entity="RequestId"
                         [search-title-new]="translationManager.getTranslation('Број захтева')"
                         search-action="equals">
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Датум и време почетка аукције')}}</label>
                <div class="app-form-element-content">
                  <input type="date" search-input search-entity="AuctionStartDateOnlyDate"
                         [search-title-new]="translationManager.getTranslation('Датум и време почетка аукције')"
                         search-action="equals">
                </div>
              </div>
            </div>
            <!-- <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Датум и време завршетка аукције')}}</label>
                <div class="app-form-element-content">
                  <input type="date" search-input search-entity="AuctionDeadline"
                         [search-title-new]="translationManager.getTranslation('Датум и време завршетка аукције')"
                         search-action="less-than-or-equal">
                </div>
              </div>
            </div> -->
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b96dc32dbf7514c031f17')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="ItemName"
                         [search-title-new]="translationManager.getTranslation('att_label_635b96dc32dbf7514c031f17')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b96d932dbf7514c031f16')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="ItemType"
                         [search-title-new]="translationManager.getTranslation('att_label_635b96d932dbf7514c031f16')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Понуђена количина добављача')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OfferedSupplierAmount"
                         [search-title-new]="translationManager.getTranslation('Понуђена количина добављача')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Понуђена цена добављача')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OfferedSupplierPrice"
                         [search-title-new]="translationManager.getTranslation('Понуђена цена добављача')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b968b32dbf7514c031f14')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OfferedAmount"
                         [search-title-new]="translationManager.getTranslation('att_label_635b968b32dbf7514c031f14')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b968d32dbf7514c031f15')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OfferedPrice"
                         [search-title-new]="translationManager.getTranslation('att_label_635b968d32dbf7514c031f15')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
          <tr class="bgc-primary-tp2 text-white">

            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="RequestId">
                {{translationManager.getTranslation('Број захтева')}}
              </a>
            </th>

            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="AuctionStartDate">
                {{translationManager.getTranslation('Датум и време почетка аукције')}}
              </a>
            </th>

            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="AuctionDeadline">
                {{translationManager.getTranslation('att_label_635b974d32dbf7514c031f18')}}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="ItemName">
                {{translationManager.getTranslation('att_label_635b96dc32dbf7514c031f17')}}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="ItemType">
                {{translationManager.getTranslation('att_label_635b96d932dbf7514c031f16')}}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање')" order
                 order-entity="OfferedSupplierAmount">
                {{translationManager.getTranslation('Понуђена количина добављача')}}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање')" order
                 order-entity="OfferedSupplierPrice">
                {{translationManager.getTranslation('Понуђена цена добављача')}}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="OfferedAmount">
                {{translationManager.getTranslation('att_label_635b968b32dbf7514c031f14')}}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="OfferedPrice">
                {{translationManager.getTranslation('att_label_635b968d32dbf7514c031f15')}}
              </a>
            </th>
            <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let xxx of items">
            <td>{{xxx.requestId}}</td>
            <td>{{xxx.auctionStartDate | appdate | appvalue}}</td>
            <td>
              <app-timer
                [selectedAuctionId]="xxx.auctionId"
                [auctionEnded]="xxx.auctionEnded"
                [auctionStarted]="xxx.auctionStarted"
                [auctionDeadline]="xxx.auctionDeadline"
                (onAuctionEnded)="auctionEnded($event)"
              ></app-timer>
            </td>
            <td>{{xxx.itemName}}</td>
            <td>{{xxx.auctionType}}</td>
            <td>{{xxx.offeredSupplierAmount}}</td>
            <td>{{xxx.offeredSupplierPrice | number : '1.2-2':'sr' }}</td>
            <td>{{xxx.offeredAmount}}</td>
            <td>{{xxx.offeredPrice * xxx.offeredAmount | number : '1.2-2':'sr' }}</td>
            <td class="right">
              <div class="table-actions">
                <!-- USLOV ZA AKCIJU -->
                <!-- xxx.auctionEnded || xxx.requestRoundSupplierStatus === 'AttendanceConfirmed' -->
                <a
                  href="javascript:;" (click)="showParticipateModalFor(xxx.requestRoundSupplierId, true)" class="green"
                  [ngClass]="{'link-disabled': !xxx.auctionStarted || xxx.auctionEnded || xxx.requestRoundSupplierStatus === 'AttendanceConfirmed'}"
                  [title]="translationManager.getTranslation('SupplierRoundList_Participate')"><i
                  class="fa fa-check"></i></a>
                <!--
                    STARI KOD - RANIJE AKO NIJE UNETA NI JEDNA PONUDA AUCITION ID JE BIO 0,
                    SADA NECE BITI SITUACIJE DA JE AUCTION ID JEDNAK 0
                -->
<!--                <a-->
<!--                  [routerLink]="['./details', xxx.auctionId]"-->
<!--                  [ngClass]="{'link-disabled': !xxx.auctionId}"-->
<!--                  [title]="translationManager.getTranslation('Детаљи')"><i-->
<!--                  class="far fa-file"></i></a>-->
                    <a
                      [routerLink]="['./details', xxx.auctionId]"
                      [title]="translationManager.getTranslation('Детаљи')"><i
                      class="far fa-file"></i></a>

                <!-- USLOV ZA EDIT: -->
                <!-- xxx.auctionEnded || xxx.requestRoundSupplierStatus !== 'AttendanceConfirmed' -->
                <a
                  [routerLink]="['./edit', xxx.auctionId, xxx.requestRoundSupplierId]"
                  [ngClass]="{'link-disabled': !xxx.auctionStarted || xxx.auctionEnded || xxx.requestRoundSupplierStatus !== 'AttendanceConfirmed'}"
                  [title]="translationManager.getTranslation('AuctionsInsertOffer')"><i
                  class="far fa-file-alt"></i></a>
<!--                <a-->
<!--                  *ngIf="xxx.auctionId == 0"-->
<!--                  [routerLink]="['./create', xxx.requestRoundSupplierId]"-->
<!--                  [queryParams]="{-->
<!--                      itemName: xxx.itemName,-->
<!--                      auctionDeadline: xxx.auctionDeadline,-->
<!--                      offeredSupplierAmount: xxx.offeredSupplierAmount,-->
<!--                      offeredSupplierPrice: xxx.offeredSupplierPrice,-->
<!--                      previousOfferedPrice: xxx.offeredPrice-->
<!--                  }"-->
<!--                  [ngClass]="{'link-disabled': xxx.auctionEnded || xxx.requestRoundSupplierStatus !== 'AttendanceConfirmed'}"-->
<!--                  [title]="translationManager.getTranslation('AuctionsInsertOffer')"><i-->
<!--                  class="far fa-file-alt"></i></a>-->
                <!--
                    STARI KOD - RANIJE AKO NIJE UNETA NI JEDNA PONUDA AUCITION ID JE BIO 0,
                    SADA NECE BITI SITUACIJE DA JE AUCTION ID JEDNAK 0
                -->
<!--                <a-->
<!--                  [routerLink]="['./rang-list', xxx.requestRoundId]"-->
<!--                  [ngClass]="{'link-disabled': !xxx.auctionId}"-->
<!--                  [title]="translationManager.getTranslation('Ранг листа')"><i-->
<!--                  class="fa fa-list-1-2"></i></a>-->
                <a
                  [routerLink]="['./rang-list', xxx.requestRoundId, xxx.auctionId]"
                  [title]="translationManager.getTranslation('Ранг листа')"><i
                  class="fa fa-list-1-2"></i></a>

                <!--                <a-->
                <!--                                                   href="javascript:;" (click)="showDeleteModalFor(xxx.auctionId)" class="red"-->
                <!--                                                   [title]="translationManager.getTranslation('Брисање')"><i-->
                <!--                class="far fa-trash-alt"></i></a>-->
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span></div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination><span>{{ translationManager.getTranslation('Страна') }}</span><select pagination-pages>
            <option>1</option>
          </select><span>{{ translationManager.getTranslation('од') }}</span><span pagination-pages-count>-</span><span
            class="app-table-pagination-arrows"><a href="javascript:;"
                                                   [title]="translationManager.getTranslation('Иди на почетак')"
                                                   pagination-first-page><i class="fas fa-angle-double-left"></i></a><a
            href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page><i
            class="fas fa-angle-left"></i></a></span><span class="app-table-pagination-arrows"><a href="javascript:;"
                                                                                                  [title]="translationManager.getTranslation('Следећа')"
                                                                                                  pagination-next-page><i
            class="fas fa-angle-right"></i></a><a href="javascript:;"
                                                  [title]="translationManager.getTranslation('Иди на крај')"
                                                  pagination-last-page><i
            class="fas fa-angle-double-right"></i></a></span><span>{{ translationManager.getTranslation('Број редова за приказ') }}</span><select
            pagination-sizes>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select></div>
        </div>
        <div class="app-table-pagination-sizes">
          <div><span>{{ translationManager.getTranslation('Укупан број слогова') }}</span><span
            pagination-total-count>-</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете артикал?') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()"><i
      class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning"><i
      class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>


<app-modal [show]="displayParticipateModal" [title]="translationManager.getTranslation('Потврди учешће')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('AuctionParticipateQuestion') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="partcipate()"><i
      class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="displayParticipateModal = false" class="btn btn-warning"><i
      class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

